const module = { name: 'theater/details/shared/exhibitorPoints', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context } = Fandango_context;


const { device: { isMobile }, theater: { chainCode } = {} } = context


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_dropdown as dropdown } from 'base-libraries';



import { Fandango_overlay as fdOverlay } from 'base-libraries';



import { Fandango_eventQueue as eventQueue } from 'require-global';



const { EventNames } = eventQueue


import { default as theaterTicketingOptions } from 'swug-fdRequire-call:theater/shared/theaterTicketingOptions';



const Selectors = {
    MODAL: 'theaterTake24455ABTest',
    OPTIONS_LIST: '#ticketing-options-list',
    SECTION: '#theater-details-header-ticketing-options',
}


const Styles = {
    BADGE_ICON: 'take2-4555-abtest__star-badge-icon',
    CONTAINER_DESKTOP: 'theater-ticketing-options__container--desktop',
    CONTAINER_MOBILE: 'take2-4555-abtest__modal-container--mobile',
    CLOSE_BTN: 'theater-ticketing-options__close-btn',
    CONTENT_DESKTOP: 'theater-ticketing-options__overlay--desktop',
    CONTENT_MOBILE: 'take2-4555-abtest__modal--mobile',
    CONTENT: 'theater-ticketing-options__overlay',
    TITLE: 'theater-ticketing-options__name',
}


const ChainCodes = {
    AMC: 'AMC',
    HARKINS: 'HRKN',
}


const StarBadgeMsg = {
    [ChainCodes.AMC]: 'Earn Points with AMC Stubs',
    [ChainCodes.HARKINS]: 'Earn Points with My Harkins Awards',
}


const EarnPointsMsg = {
    [ChainCodes.AMC]: 'Enter your AMC Stubs number in the payment step to earn your points.',
    [ChainCodes.HARKINS]: 'Enter your My Harkins Awards number in the payment step to earn your points.',
}


const iconSVG = '' +
    `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" class="${Styles.BADGE_ICON}">
<style type="text/css">
.st0{fill:#FF6900;}
.st1{fill:none;stroke:#FFFFFF;stroke-width:1.5327;stroke-miterlimit:10;}
.st2{fill:#FFFFFF;}
</style>
<circle class="st0" cx="15" cy="15" r="15"/>
<circle class="st1" cx="15" cy="15" r="12.3"/>
<polygon class="st2" points="12.6,12.3 15,7.6 17.3,12.4 22.5,13.3 18.6,16.9 19.4,22.1 14.8,19.6 10,21.9 11,16.7 7.3,12.9 "/>
</svg>`


const StyleDefs = `
.${Styles.BADGE_ICON} {
  width: 25px;
  margin-right: 8px;
  height: 25px;
  vertical-align: middle;
}

.${Styles.CONTAINER_MOBILE} {
  background-color: rgba(0, 0, 0, 0.5);
}

.${Styles.CONTENT_MOBILE} {
  top: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
  width: 90%;
  left: 50%;
}`


const DROPDOWN_NAME = 'theaterTake24455ABTest'
function appendStyles() {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = StyleDefs;
    document.querySelector('head').appendChild(styleTag);
}
function showStarBadge(chainCode) {
    const list = document.querySelector(Selectors.OPTIONS_LIST);
    const msg = StarBadgeMsg[chainCode];
    list.innerHTML = `${iconSVG}${msg}`;
}
function onClick(btn) {
    const isDesktop = !isMobile;
    const markup = '' +
        `<section id="${Selectors.MODAL}" class="${Styles.CONTENT} ${isDesktop ? Styles.CONTENT_DESKTOP : Styles.CONTENT_MOBILE}" role="dialog">
<h2 class="${Styles.TITLE}">${iconSVG}<strong>Earn Points</strong></h2>
<p>${EarnPointsMsg[chainCode]}</p>
</section>`;
    const modalSelector = `#${Selectors.MODAL}`;
    if (isDesktop) {
        dropdown.open(markup, {
            closeBtnParent: modalSelector,
            closeBtnStyle: Styles.CLOSE_BTN,
            dropdownStyle: Styles.CONTAINER_DESKTOP,
            name: DROPDOWN_NAME,
            openParent: btn.id,
            relativeParent: Selectors.SECTION,
        });
        const list = document.querySelector(Selectors.OPTIONS_LIST);
        document.querySelector(modalSelector).style.left = list ? (`${list.scrollWidth + 28}px`) : '0';
    }
    else {
        fdOverlay.open(markup, {
            closeBtnParent: modalSelector,
            closeBtnStyle: Styles.CLOSE_BTN,
            overlayStyle: Styles.CONTAINER_MOBILE,
            microModalOpts: {
                onClose(modal) {
                    modal.remove();
                }
            }
        });
    }
}
function runTest() {
    const { exhibitorPointsGroup: group } = context;
    debugLog.info(module.name, `running test "${group}" group`);
    if (group !== 'B') {
        return;
    }
    if (chainCode !== ChainCodes.AMC && chainCode !== ChainCodes.HARKINS) {
        return;
    }
    appendStyles();
    showStarBadge(chainCode);
    theaterTicketingOptions.replaceClickHandler(onClick);
}
function init() {
    if (eventQueue.hasFired(EventNames.AB_TEST_4455_READY)) {
        return runTest();
    }
    eventQueue.on(EventNames.AB_TEST_4455_READY, runTest);
}
module.exports = {
    init
};
export default module.exports;